module.exports = __webpack_public_path__ + "img/placeholder.7ac7ab7d.jpg";